import "./Loader.css";

export const Loader = () => {
  return <div className="circle"></div>;
};
